import {useMemo, useState} from 'react';

import {oneOfType, node, func} from 'prop-types';

import {API_ENDPOINTS, SNACKBAR_ACTIONS} from '../const';
import UserSecretsContext from '../contexts/UserSecretsContext';
import useHttp from '../hooks/misc/useHttp';
import useSnackbar from '../hooks/providers/useSnackbar';

// eslint-disable-next-line complexity
const UserSecretsProvider = ({children}) => {
  const [secrets, setSecrets] = useState(null);

  const {_get, _post} = useHttp();
  const {showSnackbar, closeSnackbar} = useSnackbar();

  const getUserSecrets = async () => {
    const url = API_ENDPOINTS.secrets.get;
    try {
      const {response, responseJson: data} = await _get(url);

      if (response.status === 200) {
        setSecrets(data);
        return {data, success: true, status: response.status};
      }

      return {success: false};
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      return {success: false};
    }
  };

  const updateUserSecret = async (secretName, newSecretValue) => {
    const url = API_ENDPOINTS.secrets.update;

    const snackbarId = showSnackbar(SNACKBAR_ACTIONS.UPDATE_USER_SECRET, {
      severity: 'info',
      autoHide: false,
      hasSpinner: true
    });

    try {
      const {response, responseJson: data} = await _post(url, {
        secret_name: secretName,
        secret_value: newSecretValue
      });

      closeSnackbar(snackbarId);

      if (response.status === 200) {
        showSnackbar(SNACKBAR_ACTIONS.UPDATE_USER_SECRET_SUCCESS);
        return {data, success: true, status: response.status};
      }

      return {success: false};
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      return {success: false};
    }
  };

  const useMemoDeps = [secrets, getUserSecrets, updateUserSecret];
  const value = useMemo(
    () => ({
      secrets,
      getUserSecrets,
      updateUserSecret
    }),
    useMemoDeps
  );

  return <UserSecretsContext.Provider value={value}>{children}</UserSecretsContext.Provider>;
};

UserSecretsProvider.propTypes = {
  children: oneOfType([node, func]).isRequired
};

export default UserSecretsProvider;
